import { Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";

import ImageGallery from "./ImageGallery.vue";

export default Node.create({
  name: "imagegallery",

  group: "block",
  content: "imagegalleryitem*",

  atom: true,

  parseHTML() {
    return [
      {
        tag: "image-gallery"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["image-gallery", HTMLAttributes, 0];
  },

  addNodeView() {
    return VueNodeViewRenderer(ImageGallery);
  }
});
